import * as moment from 'moment';
export function displayDate(date) {
    return moment(date).format('MM-DD-YYYY');
}
//# sourceMappingURL=date.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/util/date.js
// module id = 130
// module chunks = 0